
import { Table } from "antd";
import { RefContextLanguage } from "../providers/LanguageProvider";
import { tRecordField, tValue } from "../utils/translationFunctions";
// import * as locCon from "../LocalConstants"
import * as libCon from "../community-hats-js-library/Constants"
import { formatDistanceShort, formatMinutes } from "../community-hats-js-library/utils/dateFunctions";
import { getColorCollectionRecord, getColorIssue, isAirtableNull, isNullOrUndefined } from "../community-hats-js-library/utils/generalFunctions";


const getActionItemsGeneralColumns = (i18n) => ({

      [libCon.ATF_OVERLOOKED] : {
        title: i18n.t('actionItemOverlooked'),
        dataIndex: libCon.ATF_OVERLOOKED,
        key: 3,
        align: 'center',
        width: 60,
        render: (val, record) => <p style={{ fontSize: 12, textAlign: 'center', color: getColorIssue(record) }}>{tValue(i18n, val)}</p>
        
      },
      [libCon.ATF_STATUS] : {
        title: i18n.t('status'),
        dataIndex: libCon.ATF_STATUS,
        key: 3,
        align: 'center',
        width: 60,
        render: (val, record) => <p style={{ fontSize: 12, textAlign: 'center', color: getColorIssue(record) }}>{tValue(i18n, val)}</p>
        
      },
      [libCon.ATF_STATUS_LAST_UPDTAED] : {
        title: i18n.t('lastUpdated'),
        dataIndex: libCon.ATF_STATUS_LAST_UPDTAED,
        key: 3,
        align: 'center',
        width: 60,
        defaultSortOrder: 'descend',
        sorter: (a, b) => new Date(a[libCon.ATF_STATUS_LAST_UPDTAED]) - new Date(b[libCon.ATF_STATUS_LAST_UPDTAED]),
        render: (val, record) => <p style={{ textAlign: 'center', color: getColorIssue(record) }}>{formatDistanceShort(val)}</p>
      },      
      [libCon.ATF_AREA] : {
        title: <p>{i18n.t('area')}</p>,
        dataIndex: libCon.ATF_AREA,
        key: 1,
        align: 'center',
        width: 50,
        render: (val, record) => <p style={{ fontSize: 12, textAlign: 'center', color: getColorIssue(record) }}>{tValue(i18n, val)}</p>

      },
      [libCon.ATF_NAME] : {
        title: i18n.t('names'),
        dataIndex: libCon.ATF_NAME,
        key: 2,
        align: 'center',
        width: 100,
        fixed: "left",
        render: (val, record) => <p style={{ textAlign: 'center', color: getColorIssue(record) }}>{record[libCon.ATF_NAME] + " " + record[libCon.ATF_LAST_NAME]}</p>
      },
      [libCon.ATF_SEWA_ID] : {
        title: i18n.t('sewaId'),
        dataIndex: libCon.ATF_SEWA_ID,
        key: 3,
        align: 'center',
        width: 100,
        render: (val, record) => <p style={{ fontSize: 12, textAlign: 'center', color: getColorIssue(record) }}>{val}</p>
      },
      [libCon.ATF_TAGS] : {
        title: i18n.t('tags'),
        dataIndex: libCon.ATF_TAGS,
        key: 3,
        align: 'center',
        width: 100,
        render: (val, record) => <p>{val}</p>
      },      
      [libCon.ATF_DESCRIPTION] : {
        title: i18n.t('description'),
        dataIndex: libCon.ATF_DESCRIPTION,
        key: 3,
        align: 'center',
        width: 100,
        render: (val, record) => <p>{tRecordField(i18n, record, libCon.ATF_DESCRIPTION)}</p>
      },
      [libCon.ATF_ACTION] : {
        title: i18n.t('action'),
        dataIndex: libCon.ATF_ACTION,
        key: 3,
        align: 'center',
        width: 200,
        render: (val, record) => <p>{tRecordField(i18n, record, libCon.ATF_ACTION)}</p>
      },
      [libCon.ATF_NOTES] : {
        title: i18n.t('notes'),
        dataIndex: libCon.ATF_NOTES,
        key: 3,
        align: 'center',
        width: 200,
        render: (val, record) => <p>{val}</p>
      }

})

export function ActionItemTable({actionItemsArray, colIndex = null, pageSize = 50}) {

  const i18n = RefContextLanguage();
  const columns = getActionItemsGeneralColumns(i18n);
  const keys = colIndex === null ? Object.keys(columns) : colIndex;

  return (
    <Table dataSource={actionItemsArray} columns={keys.map( k => columns[k])} size="small" scroll={{ x: 'max-content', y: window.innerHeight * 0.65 }} pagination={{ pageSize: pageSize }} />
  );
}



const getCollectionRecordsGeneralColumns = (i18n) => ({

      
      [libCon.ATF_DATE_OF_COLLECTION] : {
        title: i18n.t('collectionDate'),
        dataIndex: libCon.ATF_DATE_OF_COLLECTION,
        key: 3,
        align: 'center',
        width: 60,
        defaultSortOrder: 'descend',
        sorter: (a, b) => new Date(a[libCon.ATF_DATE_OF_COLLECTION]) - new Date(b[libCon.ATF_DATE_OF_COLLECTION]),
        render: (val, record) => <p style={{ textAlign: 'center', color: getColorCollectionRecord(record) }}>{formatDistanceShort(val)}</p>
      },      
      [libCon.ATF_DURATION] : {
        title: i18n.t('duration'),
        dataIndex: libCon.ATF_DURATION,
        key: 1,
        align: 'center',
        width: 50,
        render: (val, record) => <p style={{ fontSize: 12, textAlign: 'center', color: getColorCollectionRecord(record) }}>{isNullOrUndefined(val) || isAirtableNull(val) ? "---" :  formatMinutes(val / 60)}</p>

      },      
      [libCon.ATF_STATUS] : {
        title: i18n.t('status'),
        dataIndex: libCon.ATF_STATUS,
        key: 3,
        align: 'center',
        width: 60,
        render: (val, record) => <p style={{ fontSize: 12, textAlign: 'center', color: getColorCollectionRecord(record) }}>{tValue(i18n, val)}</p>
        
      },      
      [libCon.ATF_NOTES] : {
        title: i18n.t('notes'),
        dataIndex: libCon.ATF_NOTES,
        key: 3,
        align: 'center',
        width: 200,
        render: (val, record) => <p>{val}</p>
      }

})

export function CollectionRecordTable({recordsArray, colIndex = null, pageSize = 50}) {

  const i18n = RefContextLanguage();
  const columns = getCollectionRecordsGeneralColumns(i18n);
  const keys = colIndex === null ? Object.keys(columns) : colIndex;

  return (
    <Table dataSource={recordsArray} columns={keys.map( k => columns[k])} size="small" scroll={{ x: 'max-content', y: window.innerHeight * 0.65 }} pagination={{ pageSize: pageSize }} />
  );
}


